export const DOMAIN = {
  beta: 'test',
  gamma: 'test',
  prod: 'prod',
};

export const REALM = {
  'eu-west-1': 'EUAmazon',
  'us-east-1': 'USAmazon',
  'us-west-2': 'FEAmazon',
};

export const SITE = {
  beta: 'AACChrome.Beta',
  gamma: 'AACChrome.Gamma',
  prod: 'AACChrome.Prod',
};

const footerToggleEndpoint = '/common/forceDesktopSite?force_desktop_site=';
export const FOOTER_FORCE_DESKTOP_ENDPOINT = `${footerToggleEndpoint}true&ref=`;
export const FOOTER_FORCE_MOBILE_ENDPOINT = `${footerToggleEndpoint}false&ref=`;
export const CONSOLE_HEADER_SECTION_ELEMENT_ID = 'console-header-section';
export const CONSOLE_HEADER_SECTION_ID = `#${CONSOLE_HEADER_SECTION_ELEMENT_ID}`;
export const CONSOLE_HEADER_RESIZE_EVENT = 'ChromeHeaderResize';
export const MOBILE_MENU_Z_INDEX = 398; // mobile menu

/**
 * a3cConfig.loadBehavior value that opts a page out of A3C entirely.
 * A3ChatLoader already honors it (never loads the chat bundle); ChromeUI
 * additionally hides the Ads Agent nav button and the embedded chat panel,
 * including the A3C_EVERYWHERE default-agent fallback.
 */
export const A3C_LOAD_BEHAVIOR_DISABLED = 'DISABLED';

export enum WeblabedFeatures {
  AAC_WEBLAB_TEST = 'AAC_WEBLAB_TEST', // This weblab doesn't exist and is only used for testing purposes
  STARDUST_BANNER_UI = 'STARDUST_BANNER_UI',
  CONTEXT_SERVICE_ADSP_GLOBAL_ACCOUNT = 'CONTEXT_SERVICE_ADSP_GLOBAL_ACCOUNT',
  HELP_ME_HERE_SGA_TOOLTIP = 'HELP_ME_HERE_SGA_TOOLTIP',
  ADS_NAVIGATOR_P0 = 'ADS_NAVIGATOR_P0',
  CHROME_THEME_MODES_CONTROL = 'CHROME_THEME_MODES_CONTROL',
  NAV_ADS_PROD = 'NAV_ADS_PROD',
  ADS_INTERSTITIAL_MODAL = 'ADS_INTERSTITIAL_MODAL',
  LEGACY_CONVERSION_METRICS_URL_REWRITE_ANDON_CORD = 'LEGACY_CONVERSION_METRICS_URL_REWRITE_ANDON_CORD',
  ADS_PORTAL_MIDWAY_REFRESH = 'ADS_PORTAL_MIDWAY_REFRESH',
  MIGRATE_NAV_ACCOUNTSWITCHER_TO_TRIM = 'MIGRATE_NAV_ACCOUNTSWITCHER_TO_TRIM',
  MIGRATE_NAV_ACCOUNTSWITCHER_TO_TRIM_T2 = 'MIGRATE_NAV_ACCOUNTSWITCHER_TO_TRIM_T2',
  MIGRATE_INTERSTITIAL_TO_TRIM = 'MIGRATE_INTERSTITIAL_TO_TRIM',
  MIGRATE_INTERSTITIAL_TO_TRIM_T2 = 'MIGRATE_INTERSTITIAL_TO_TRIM_T2',
  A3C_EVERYWHERE = 'A3C_EVERYWHERE',
  A3C_EVERYWHERE_T2 = 'A3C_EVERYWHERE_T2',
  A3C_EVERYWHERE_UCB = 'A3C_EVERYWHERE_UCB',
  A3C_EVERYWHERE_UCM = 'A3C_EVERYWHERE_UCM',
  ADS_AI_REBRAND = 'ADS_AI_REBRAND',
  NOTIFICATIONS_WWS_DIRECT = 'ADS_MARKETING_BANNERS_BACKEND_SWAP_TO_WWS',
  ADS_SPOTLIGHT_LAUNCH = 'ADS_SPOTLIGHT_LAUNCH',
}

export enum Components {
  HEADER = 'AACChromeHeader',
  FOOTER = 'AACChromeFooter',
  NAV = 'AACChromeNav',
  PIVOT_NAV = 'AACChromePivotNav',
  PAGE_HEADER = 'AACChromePageHeader',
  GLOBAL_HEADER = 'AACChromeGlobalHeader',
  MARKETPLACE_SWITCHER = 'AACChromeMarketplaceSwitcher',
}

export const CHROME_APP_NAME = {
  Header: 'Header',
  Nav: 'Nav',
  PivotNav: 'PivotNav',
  Footer: 'Footer',
  GlobalHeader: 'GlobalHeader',
  PageHeader: 'PageHeader',
  MarketplaceSwitcher: 'MarketplaceSwitcher',
};

export const staticImgSrcWithCache =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-logo._CB564109095_.svg';
export const staticInternalImgSrcWithCache =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-internal-logo._CB564109095_.svg';
export const staticAgentImgSrcWithCache =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-agent-logo-white._CB1790865772_.svg';
export const staticImgSrc =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-logo.svg';
export const staticInternalImgSrc =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-internal-logo.svg';
export const staticAgentImgSrc =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-agent-logo-white.svg';
// TODO: add the dark logo to the GlobalNavHandler.java
// https://code.amazon.com/packages/AACChromeGlobalNav/blobs/73564f48db090e0d28daccaf711b5136de72fc07/--/src/com/amazon/aac/chrome/globalnav/handler/GlobalNavHandler.java#L196-L204
export const staticDarkImgSrcWithCache =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-logo-dark._CB1762968808_.svg';
export const staticDarkImgSrc =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-logo-dark.svg';

// Advertising API client id for the console chrome navigation surface.
// Sourced from AdvertisingExperienceChromeNavigation
export const CONSOLE_NOTIFICATIONS_API_CLIENT_ID =
  'amzn.advertising.789c2d8cdb11002108035bca7a02d27f6302de4f26b379c80d090e256c706460a3429f3c5995adbf50bc8d94d9b907da332c36248e32e6d07adefe7d76e302c12f15c9';

export const spoofingQueryParamName = 'kerberos';
export const quitSpoofingQueryParamValue = 'off';
export const ATC_EXTERNAL_TOGGLE = 'ATC_EXTERNAL_TOGGLE';
export const CC_MODAL_TOOLBAR_ID = 'aac-toolbar-item-create-campaign-modal';
export const CC_MODAL_BULLSEYE_TOOLBAR_ID =
  'aac-toolbar-item-create-campaign-modal-front-end';
export const CC_MODAL_MENU_ITEM_TOOLBAR_ID =
  'aac-menu-item-unified-campaign-creation';
export const CM_TOOLBAR_ID = 'aac-toolbar-item-sponsored-ads';
export const CAMPAIGNS_MENU_ITEM_ID = 'aac-menu-item-campaigns';
export const CAMPAIGN_MANAGER_TOOLBAR_ID = 'aac-toolbar-item-campaign-manager';
export const CHOOSE_ACCOUNT_PATH = '/choose-account';
export const NAV_MIGRATION_ANNOUNCEMENT_ID = 'nav-migration-2026';
